/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2023-11-07 14:20:59
 * @LastEditors: yusha
 * @LastEditTime: 2023-11-08 15:33:28
 * @FilePath: \ckb-easy-h5-fed\src\common\Maps.ts
 * @Description: 站点maps
 */
import { EnumStationList } from './Enums';
type ValueOf<T> = T[keyof T];
export type EnumStationListValue = ValueOf<typeof EnumStationList>;
const mapStationList = new Map<EnumStationListValue, boolean>();
mapStationList.set('JapanStation', true);
mapStationList.set('KoreaStation', false);
export { mapStationList };
